import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { useAuth } from "@/contexts/auth"
import { StringHelper } from "@/utils"
const getSubscriptions = async (
  params: SubscriptionsSearchParams
) => {
  const customerDocument = StringHelper.onlyAlphanumeric(
    params?.customerDocument
  )
  const newParams = {
    customerDocument: customerDocument,
    ownId: params.ownId,
    code: params.code,
    status: params.status,
    paymentMethod: params.paymentMethod,
    from: params.from,
    to: params.to,
    page: params.page,
    pageSize: params.pageSize,
    whitelabel_ids: params.whitelabel_ids,
  }
  const queryString =
    StringHelper.objectToQueryString(newParams)
  const url = `${ENDPOINTS.SUBSCRIPTIONS}?${queryString}`
  const { data } =
    await api.get<SubscriptionsResponseType>(url)
  return data
}
const useSubscriptions = (
  params: SubscriptionsSearchParamsType,
  enabled = false
) => {
  const { selectedWhiteLabel } = useAuth()
  const newParams = {
    ...params,
    whitelabel_ids: selectedWhiteLabel?.uuid,
  }
  return useQuery({
    queryKey: [ENDPOINTS.SUBSCRIPTION, newParams],
    queryFn: () => getSubscriptions(newParams),
    enabled,
  })
}
export default useSubscriptions
